import { render, staticRenderFns } from "./CorrelationWidget.vue?vue&type=template&id=640f230e&scoped=true&"
import script from "./CorrelationWidget.vue?vue&type=script&lang=js&"
export * from "./CorrelationWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640f230e",
  null
  
)

export default component.exports